import ImportConfigComp from "../../../Components/AdminComponents/SuperUser/ImportConfigComp";

const ImportConfig = () => {
  return <ImportConfigComp />;
};

export default ImportConfig;
